import React, { useEffect, useState, lazy, Suspense, useRef } from "react"
import { ApolloClient, InMemoryCache, HttpLink, gql } from "@apollo/client"
import { ServiceDetail } from "@hometown/react-hometown-lib"
import LayoutDumpster from "../components/layout-dumpster"
import RelatedServices from '../components/related-services'
import PopularServices from '../components/popular-services'
// import PopularArticles from '../components/popular-articles'
// import ZipFinderKpps from '../components/zip-finder-kpps'
import KppTips from "../components/kpptips"
import HowToGuide from '../components/how-to-guides-dumpsters'
import ProfilesCardsDumpster from "../components/profiles-cards-dumpsters"
import EmptyProfilesDumpster from "../components/empty-profiles-dumpster"
import BlockHowToGuidesJunkRemoval from "../components/how-to-guides-junk-removal"
import Banner from "../components/banner"
import Breadcrumb from "../components/breadcrumb"
// import ViewDumpsterPricesForm from "../components/viewDumpsterPricesForm";
import PopularArticlesKpp from "../components/popular-articles-kpp"
import SidebarForm from "../components/sidebarForm"
import KppSidebarSearchForm from "../components/kpp-sidebar-search-form"
import TypicalPricesChart from "../components/typical-prices-chart"
import QuoteRequestModalLibrary from "../components/quote-request-modal-library"
import OndeffModal from "../components/OndeffModal"
import { trackBookingSubmission, formatBookingJson } from "../helpers/helpers"
import ComparePricesLinks from "../components/compare-prices-links"
const OnlineBooking = lazy(() => import('@hometown/react-hometown-lib').then((module) => ({ default: module.OnlineBooking })));

const BASE_SERVICE_ID = "62a9f2cd61706a135071a7e3"
// Must mirror the ServiceSeeker/profile-page query exactly — this backend only
// returns `nodes` when the full query (popularPros/sponsoredPros/pageInfo + extra
// declared vars) is requested. The trimmed query returns `nodes: null`.
const HT_PRICE_QUERY = gql`
  query HtServices($idBaseService: String!, $wasteType: [Int], $dumpsterType: Int, $dumpsterSize: String, $proId: Int, $placesId: [Int], $skip: Int, $limit: Int, $event: event, $datePeriod: Int, $includeNullPrices: Boolean, $pros: [Int]) {
    htServices(idBaseService: $idBaseService, wasteType: $wasteType, dumpsterType: $dumpsterType, dumpsterSize: $dumpsterSize, proId: $proId, placesId: $placesId, skip: $skip, limit: $limit, event: $event, datePeriod: $datePeriod, includeNullPrices: $includeNullPrices, pros: $pros) {
      nodes { _id price proId dumpsterSize description placesId { placeId distanceFee } }
      popularPros
      sponsoredPros { _id price proId dumpsterSize description placesId { placeId distanceFee } }
      pageInfo { currentPage hasNextPage perPage totalCount }
    }
  }
`

const singularize = (text) => text && text.endsWith('s') ? text.slice(0, -1) : text

const CheckIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
    </svg>
)

const PppGetMoreQuotesCard = ({ proCount, projectTypeName, placeName, cardsHaveRealPrices, googlePlaceAutocompleteApiKey }) => {
    // Plural on purpose here (unlike the singularized title/subtext below): "companies offer
    // dumpsters" is a real plural noun, not a category label like "Dumpster Prices".
    const hasResults = proCount > 0
    const countLine = hasResults ? `${proCount} ${proCount === 1 ? 'Dumpster Company' : 'Dumpster Companies'}` : 'Dumpster Companies'
    const metaLine = hasResults
        ? `Offer ${projectTypeName?.toLowerCase() || 'dumpsters'} in ${placeName || 'your area'}`
        : `Find ${projectTypeName?.toLowerCase() || 'dumpsters'} in ${placeName || 'your area'}`
    return (
        <div className="cardContainer card-service-visible ppp-quotes-shadow">
            <div className="card ppp-quotes-card">
                <div className="cardPointer">
                    <div className="cardPadding ppp-quotes-card__padding" style={{ justifyContent: 'flex-start' }}>
                        <div className="ppp-quotes-card__header">
                            <span className="ppp-quotes-card__badge">
                                <CheckIcon className="ppp-quotes-card__badge-icon" />
                                Instant Local Match
                            </span>
                            <span className="ppp-quotes-card__free-tag">100% Free &amp; Fast</span>
                        </div>
                        <div className="ppp-quotes-card__banner">
                            <div className="ppp-quotes-card__icon-box">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <div>
                                <p className="ppp-quotes-card__count">{countLine}</p>
                                <p className="ppp-quotes-card__meta">{metaLine}</p>
                            </div>
                        </div>
                        <h3 className="ppp-quotes-card__headline">Want More Quotes?</h3>
                        <p className="ppp-quotes-card__subheadline">We'll gather quotes and send you the results</p>
                        <ul className="ppp-quotes-card__items">
                            {['Check real-time availability', 'Compare competitive prices', 'Book online in minutes'].map((label, index) => (
                                <li key={index} className="ppp-quotes-card__item">
                                    <span className="ppp-quotes-card__icon">
                                        <CheckIcon />
                                    </span>
                                    <span className="ppp-quotes-card__item-text"><strong>{label}</strong></span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="buttonContainer marginButtonContainer ppp-quotes-card__footer">
                    <div className="ppp-quotes-card__response-time">Avg response time: <strong>&lt; 15 mins</strong></div>
                    <QuoteRequestModalLibrary
                        startVisible={false}
                        ondeffCode="priceAndAvailabilityForm"
                        btnLabel="Get pricing & availability"
                        class="bookButton"
                        isOnCard={true}
                        googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                    />
                </div>
            </div>
        </div>
    )
}

const DumpsterKPP = ({ pageContext }) => {
    const cards = pageContext.cards
    const sponsoredCards = pageContext.sponsoredCards
    const title = pageContext.title
    const projectTypeName = pageContext.keyword_group?.name || '';
    const profiles = pageContext.profiles.length > 0 ? pageContext.profiles[0] : [];
    const sponsoredProfiles = pageContext.sponsoredProfiles?.length > 0 ? pageContext.sponsoredProfiles[0] : [];
    const env = pageContext.env
    const articles = pageContext.articles
    const code = pageContext.code
    const codes = pageContext.codes.length > 0 ? pageContext.codes : []
    const populars = pageContext.populars.length > 0 ? pageContext.populars : []
    const related = pageContext.related
    const keygroup_name = pageContext.page === 'ppp' ? pageContext.keyword_group?.name : undefined
    const bread = pageContext.page === 'ppp' ? pageContext.bread?.url : undefined
    const tip = pageContext.tips.length > 0 ? pageContext.tips[0] : {}

    // const text = code === 'junk-removal' ? 'Get matched to top-rated junk removal services' : 'Find the top dumpster rental companies serving your hometown';
    const empty = profiles.length > 0 ? false : true

    const place =
    {
        name: pageContext.place.name,
        ht: pageContext.place.ht,
        state:
        {
            name: pageContext.place.state.name,
            av: pageContext.place.state.av,
            slug: pageContext.place.state.slug
        }
    }



    const seo_desc = pageContext.seo_desc
    const seo =
    {
        url: pageContext.url,
        env: env,
        place: place,
        code: code,
        page: pageContext.page,
        seo_desc: seo_desc,
        schema: pageContext.schemaOrg
    }

    const online_booking_pros = pageContext.enabledBooking
    const typicalPricesData = pageContext.typicalPricesData || null
    const pppPrices = pageContext.pppPrices || {}
    const pageWasteType = pageContext.pageWasteType || 1
    const isPPP = pageContext.page === 'ppp'
    const apolloURL = `${process.env.GATSBY_BOOKABLE_SERVICE_API}`

    const getPPPOpeningParagraph = () => {
        const build = env.build
        const city = place.name
        const allServices = Object.values(pppPrices).flat()
        const fmt = (n) => `$${Math.round(n)}`

        if (build === 'pppconstruction') {
            const prices = allServices.map(s => parseFloat(s.price)).filter(p => !isNaN(p) && p > 0)
            const sizes = allServices.map(s => s.size).filter(s => s !== null)
            if (prices.length >= 2) {
                const minP = fmt(Math.min(...prices))
                const maxP = fmt(Math.max(...prices))
                const minS = Math.min(...sizes)
                const maxS = Math.max(...sizes)
                return `In ${city}, construction dumpster rental prices typically range from ${minP} to ${maxP}. Roll-off dumpsters for construction debris are available in sizes ranging from ${minS} to ${maxS} cubic yards. Your final cost will depend on your exact location, the dumpster size you choose, and the weight of your debris.`
            }
            return `Looking for a construction dumpster rental in ${city}? Roll-off dumpsters for construction debris are generally available in sizes ranging from 10 to 40 cubic yards to handle any size project. Rates vary by provider so the best way to get accurate pricing for your specific location and waste type is to request pricing and availability from the haulers listed below.`
        }

        const EXACT_SIZE = { ppp10: 10, ppp20: 20, ppprolloff: 30 }
        const exactSize = EXACT_SIZE[build]
        if (!exactSize) return null

        const SIZE_RANGE = { ppp10: [0, 12], ppp20: [13, 24], ppprolloff: [25, Infinity] }
        const [rangeMin, rangeMax] = SIZE_RANGE[build] || [0, Infinity]

        const prosWithExactPrice = Object.values(pppPrices)
            .filter(services => services.some(s => s.size === exactSize && parseFloat(s.price) > 0))
        const exactPrices = prosWithExactPrice
            .flatMap(services => services)
            .filter(s => s.size === exactSize)
            .map(s => parseFloat(s.price))
            .filter(p => !isNaN(p) && p > 0)

        const rangeServices = allServices.filter(s => s.size !== null && s.size >= rangeMin && s.size <= rangeMax)
        const rangePrices = rangeServices.map(s => parseFloat(s.price)).filter(p => !isNaN(p) && p > 0)
        const rangeSizes = rangeServices.map(s => s.size)

        if (prosWithExactPrice.length >= 2) {
            const minP = fmt(Math.min(...exactPrices))
            const maxP = fmt(Math.max(...exactPrices))
            if (build === 'ppp10') return `A 10-yard dumpster rental in ${city} typically costs between ${minP} and ${maxP}. Depending on local availability, similar small dumpster sizes like 8 yard and 12 yard dumpsters may also be available.`
            if (build === 'ppp20') return `A 20-yard dumpster rental in ${city} typically costs between ${minP} and ${maxP}. As the most popular roll-off size, it is ideal for medium-sized projects like roofing jobs, deck removals, or whole-house cleanouts. Depending on local availability, similar sizes like 15 yard dumpsters may also be featured.`
            if (build === 'ppprolloff') return `A 30-yard dumpster rental in ${city} typically costs between ${minP} and ${maxP}. Designed for large-scale waste, this high-capacity dumpster is ideal for major home additions, estate cleanouts, or light demolition. Depending on local inventory, 40-yard dumpsters may also be available to suit your specific job.`
        }

        if (rangePrices.length >= 2) {
            const minP = fmt(Math.min(...rangePrices))
            const maxP = fmt(Math.max(...rangePrices))
            const minS = Math.min(...rangeSizes)
            const maxS = Math.max(...rangeSizes)
            if (build === 'ppp10') return `Prices for a 10-yard dumpster rental in ${city}—and similar compact options ranging from ${minS} to ${maxS} cubic yards—generally fall between ${minP} and ${maxP}. This rate range covers the area's small roll off dumpsters, with your final cost depending on the exact size you choose, your specific location, and the weight of your debris.`
            if (build === 'ppp20') return `When looking for a 20-yard dumpster rental in ${city}, typical prices for mid-sized roll-off containers—ranging from ${minS} to ${maxS} cubic yards—generally fall between ${minP} and ${maxP}. Whether you rent an exact 20-yard container or a comparable medium size, your final cost will depend on your exact location and debris weight.`
            if (build === 'ppprolloff') return `When looking for a 30-yard dumpster rental in ${city}, typical prices for large roll-off containers—ranging from ${minS} to ${maxS} cubic yards—generally fall between ${minP} and ${maxP}. Whether you rent an exact 30-yard bin or a comparable high-capacity size, your final cost will depend on your exact location and waste type.`
        }

        if (build === 'ppp10') return `Looking to rent a 10-yard dumpster in ${city}? This compact roll-off container is the perfect size for small home renovations, smaller cleanouts, or heavy debris disposal. While local dumpster rates vary by provider, you can easily compare available options by requesting pricing and availability below.`
        if (build === 'ppp20') return `Looking to rent a 20-yard dumpster in ${city}? As the industry's most popular and versatile roll-off size, it is perfect for medium renovations, carpet removals, or large property decluttering. Request pricing and availability below to compare pricing from top-rated local dumpster services.`
        if (build === 'ppprolloff') return `Planning a large project and need a 30-yard dumpster rental in ${city}? This high-capacity roll-off container is built to handle bulky materials from major home additions, estate cleanouts, or commercial construction debris. Request pricing and availability below to compare pricing from top-rated haulers in your area.`

        return null
    }

    const pppOpeningParagraph = isPPP ? getPPPOpeningParagraph() : null
    const allResultsCount = [...new Set([...(sponsoredProfiles || []), ...(profiles || [])].map(p => p.id))]
        .reduce((sum, id) => sum + (pppPrices[id]?.length || 0), 0)
    const ondeffModalRef = useRef()
    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth <= 992)
    const [isHorizontal, setIsHorizontal] = useState(typeof window !== "undefined" && window.innerWidth <= 992 && (window.innerWidth >= window.innerHeight))
    const [showBooking, setShowBooking] = useState(false)
    const [bookingInitialData, setBookingInitialData] = useState()
    const [bookingProInfo, setBookingProInfo] = useState({})
    const [cardDetailsData, setCardDetailsData] = useState(null)
    const [showFailureMessage, setShowFailureMessage] = useState(false)
    const [cardsHaveRealPrices, setCardsHaveRealPrices] = useState(false)
    const [userPlaceId, setUserPlaceId] = useState(null)
    const [detailWasteType, setDetailWasteType] = useState(1)
    const [storedFullFormData] = useState(() => {
        try {
            const stored = JSON.parse(typeof window !== 'undefined' ? localStorage.getItem('onlineBookingData') || 'null' : 'null')
            let val = stored?.finalDataForBooking?.find(e => e.key === 'fullFormData')?.value ||
                      stored?.initialValues?.find(e => e.key === 'fullFormData')?.value ||
                      null
            // initialValues stores fullFormData as { odf_street, odf_postal_code, ... } object
            // OnlineBooking expects a JSON string of [[key, value], ...] (GooglePlace array format)
            if (val && typeof val === 'object' && !Array.isArray(val)) {
                const pairs = Object.entries(val)
                    .filter(([k]) => k.startsWith('odf_'))
                    .map(([k, v]) => [k.replace('odf_', ''), v])
                val = pairs.length > 0 ? JSON.stringify(pairs) : null
            }
            return val
        } catch (e) { return null }
    })

    const serviceSeekerCallback = (data) => {
        const service = data?.find(d => d.key === 'service')?.value
        const profileData = data?.find(d => d.key === 'profileData')?.value
        const proUrl = data?.find(d => d.key === 'proUrl')?.value
        setBookingProInfo({
            proId: service?.proId || profileData?.proId,
            proName: profileData?.n || '',
            backUrl: proUrl || (typeof window !== 'undefined' ? window.location.pathname : '/'),
        })
        let normalizedData = data || []
        if (!normalizedData.find(d => d.key === 'wasteType'))    normalizedData = [...normalizedData, { key: 'wasteType', value: 1 }]
        if (!normalizedData.find(d => d.key === 'fullFormData')) {
            // Read fresh from localStorage to pick up any address entered via modal
            let freshFullFormData = storedFullFormData
            try {
                const stored = JSON.parse(typeof window !== 'undefined' ? localStorage.getItem('onlineBookingData') || 'null' : 'null')
                let val = stored?.finalDataForBooking?.find(e => e.key === 'fullFormData')?.value ||
                          stored?.initialValues?.find(e => e.key === 'fullFormData')?.value ||
                          null
                if (val && typeof val === 'object' && !Array.isArray(val)) {
                    const pairs = Object.entries(val)
                        .filter(([k]) => k.startsWith('odf_'))
                        .map(([k, v]) => [k.replace('odf_', ''), v])
                    val = pairs.length > 0 ? JSON.stringify(pairs) : null
                }
                if (val) freshFullFormData = val
            } catch (e) {}
            normalizedData = [...normalizedData, { key: 'fullFormData', value: freshFullFormData }]
        }
        if (!normalizedData.find(d => d.key === 'placeId'))      normalizedData = [...normalizedData, { key: 'placeId', value: null }]
        setBookingInitialData(normalizedData)
        setCardDetailsData(null)
        setShowBooking(true)
    }

    const handleBackOnlineBooking = (data) => {
        setShowBooking(false)
    }

    const handleCardDetailsClick = (data) => {
        setShowFailureMessage(false)
        setDetailWasteType(1)
        setCardDetailsData(data)
    }

    const handleBackFromCardDetails = () => {
        setShowFailureMessage(false)
        setCardDetailsData(null)
    }

    const handleChangeServiceInDetails = (serviceId) => {
        setCardDetailsData(prev => {
            const newService = (prev.proServices || []).find(s => s.id === serviceId) || prev.service
            return { ...prev, service: newService }
        })
    }

    const ondeffProIdRef = useRef(null)
    const ondeffDetailRef = useRef(null)
    const ondeffCallback = (proId) => {
        ondeffProIdRef.current = proId || null
        // Snapshot the detail context (if the modal is opened from a ServiceDetail).
        // null means the modal was opened from a card on the panel page.
        ondeffDetailRef.current = cardDetailsData || null
        ondeffModalRef.current?.triggerChangeShowModal()
    }

    // On redirect to /book we intentionally leave the modal + loader visible until the
    // navigation completes. If the user hits back, the browser restores this page from
    // the bfcache with that frozen state, so the loader would still be spinning — reset it.
    useEffect(() => {
        const onPageShow = (e) => {
            if (e.persisted) ondeffModalRef.current?.forceClose()
        }
        window.addEventListener('pageshow', onPageShow)
        return () => window.removeEventListener('pageshow', onPageShow)
    }, [])

    useEffect(() => {
        if(code === 'dumpster') {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 992);
                setIsHorizontal(window.innerWidth >= window.innerHeight)
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []);

    return (
        <LayoutDumpster seo={seo} env={env} code={code} hidden={true} defaultStyles={{ maxWidth: '1920px', margin: 'auto', width: '100%' }} notShowHeader={code === 'dumpster' && isHorizontal && isMobile}>
            <OndeffModal
                ref={ondeffModalRef}
                ondeffCode="viewPricesForm"
                startVisible={false}
                googlePlaceAutocompleteApiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`}
                callBackAfterSubmit={async (formData) => {
                    // Keep the modal open with a loader over it until everything resolves
                    ondeffModalRef.current?.setExternalLoading(true)
                    // detailContext set => opened from a ServiceDetail; null => opened from a card
                    const detailContext = ondeffDetailRef.current
                    const isFromDetail = !!detailContext
                    let placeId = pageContext.place.i
                    let wasteType = 1
                    try {
                        const parsed = typeof formData === 'string' ? JSON.parse(formData) : formData
                        const zip = parsed.odf_postal_code
                        const city = parsed.odf_locality?.replace(/ /g, '-')
                        if (parsed.wasteType) wasteType = +(Array.isArray(parsed.wasteType) ? parsed.wasteType[0] : parsed.wasteType)
                        console.log('[PPP viewPrices] DRUPAL env:', process.env.GATSBY_DRUPAL_API_MANAGMENT, '| zip:', zip, '| city:', city, '| wasteType:', wasteType)
                        if (zip && city) {
                            const res = await fetch(
                                `${process.env.GATSBY_DRUPAL_API_MANAGMENT}/place-by-zip-and-name/${zip}/${city}`,
                                { headers: { 'Ocp-Apim-Subscription-Key': '30ca1663de42420bb4a9894d1898e91e' } }
                            )
                            const data = await res.json()
                            console.log('[PPP viewPrices] place-by-zip-and-name response:', data)
                            if (data?.id) placeId = +data.id
                        }
                    } catch (e) { console.log('[PPP viewPrices] placeId resolve error:', e) }
                    console.log('[PPP viewPrices] isFromDetail:', isFromDetail, '| resolved placeId:', placeId, '| detail proId:', detailContext?.profileData?.proId, '| SEARCH_API:', process.env.GATSBY_BOOKABLE_SEARCH_API)
                    // Always persist the selection so the form stays prefilled next time.
                    formatBookingJson(formData, placeId)
                    setShowFailureMessage(false)
                    // The panel page represents a specific place + waste type. If the selection
                    // doesn't match BOTH, this is a different search: don't try to load prices here.
                    const matchesPage = (+placeId === +pageContext.place.i) && (+wasteType === +pageWasteType)
                    console.log('[PPP viewPrices] matchesPage:', matchesPage, '| pagePlace:', pageContext.place.i, '| pageWasteType:', pageWasteType)
                    if (!matchesPage) {
                        if (isFromDetail) {
                            setShowFailureMessage(true)
                            ondeffModalRef.current?.forceClose()
                        } else {
                            // Card: send to /book with the just-entered address (kept in storage)
                            window.location.href = '/book'
                        }
                        return
                    }
                    try {
                        const apolloClient = new ApolloClient({
                            link: new HttpLink({ uri: process.env.GATSBY_BOOKABLE_SEARCH_API, headers: { 'Ocp-Apim-Subscription-Key': '30ca1663de42420bb4a9894d1898e91e' } }),
                            cache: new InMemoryCache(),
                            defaultOptions: { query: { fetchPolicy: 'no-cache', errorPolicy: 'all' } },
                        })
                        const result = await apolloClient.query({
                            query: HT_PRICE_QUERY,
                            variables: {
                                idBaseService: BASE_SERVICE_ID,
                                wasteType: [wasteType],
                                placesId: [placeId],
                                proId: isFromDetail && detailContext.profileData?.proId ? +detailContext.profileData.proId : undefined,
                                skip: 0,
                                limit: 100,
                            },
                        })
                        const nodes = result.data?.htServices?.nodes || []
                        console.log('[PPP viewPrices] nodes returned:', nodes.length, nodes.map(n => ({ proId: n.proId, size: n.dumpsterSize, desc: n.description, price: n.price })))
                        const sizeFromTitle = (title) => { const m = title?.match(/(\d+)\s*yard/i); return m ? parseInt(m[1]) : 9999 }
                        const priceWithFee = (node) => {
                            const placeData = node.placesId?.find(p => +p.placeId === placeId)
                            const distanceFee = placeData?.distanceFee ? parseFloat(placeData.distanceFee) : 0
                            return node.price ? (parseFloat(node.price) + distanceFee).toFixed(2) : null
                        }

                        if (isFromDetail) {
                            // Detail: show the services this pro actually offers for the selected
                            // waste type (the query already filtered by proId + place + wasteType).
                            // Don't anchor on the previously-viewed size — for a different waste type
                            // the available sizes can differ. Reuse the pro's display objects
                            // (title/subtitle/details/images) matched by size/description and overlay
                            // the real _id + price for this place.
                            const proId = detailContext.profileData?.proId
                            const proNodes = nodes.filter(s => String(s.proId) === String(proId))
                            const displayServices = detailContext.proServices || [detailContext.service]
                            const matchDisplay = (node) => displayServices.find(svc =>
                                svc.title?.toLowerCase() === node.description?.toLowerCase() ||
                                (sizeFromTitle(node.description) !== 9999 && sizeFromTitle(node.description) === sizeFromTitle(svc.title)))
                            console.log('[PPP viewPrices] DETAIL proNodes:', proNodes.length, '| viewed service:', detailContext.service?.title)
                            if (proNodes.length > 0) {
                                const availableServices = proNodes.map(node => {
                                    const base = matchDisplay(node) || detailContext.service
                                    return { ...base, id: node._id, price: priceWithFee(node), title: base?.title || node.description }
                                })
                                // Keep the currently-viewed size if it's still available, else default to the first
                                const viewedSize = sizeFromTitle(detailContext.service?.title)
                                const current = availableServices.find(s => sizeFromTitle(s.title) === viewedSize) || availableServices[0]
                                setDetailWasteType(wasteType)
                                setUserPlaceId(placeId)
                                setCardDetailsData(prev => prev ? ({ ...prev, placeId, service: current, proServices: availableServices }) : prev)
                                ondeffModalRef.current?.forceClose()
                            } else {
                                setShowFailureMessage(true)
                                ondeffModalRef.current?.forceClose()
                            }
                        } else {
                            // Card: reload the page's prices if any of this page's pros serve the place, else go to /book
                            const ourProIds = Object.keys(pppPrices || {})
                            const hasServiceForOurPros = nodes.some(s => s.proId && ourProIds.includes(String(s.proId)))
                            console.log('[PPP viewPrices] CARD ourProIds:', ourProIds, '| hasServiceForOurPros:', hasServiceForOurPros)
                            if (hasServiceForOurPros) {
                                setUserPlaceId(placeId)
                                ondeffModalRef.current?.forceClose()
                            } else {
                                // Keep modal + loader visible until the redirect navigates away
                                window.location.href = '/book'
                            }
                        }
                    } catch (e) {
                        console.log('[PPP viewPrices] query error:', e)
                        if (isFromDetail) {
                            setShowFailureMessage(true)
                            ondeffModalRef.current?.forceClose()
                        } else {
                            window.location.href = '/book'
                        }
                    }

                }}
            />
            {!showBooking && !cardDetailsData && <div className="top-kpp-container" >
                <div className="kpp-mobile-breadcrumb">
                    <div className="container">
                        <Breadcrumb
                            code={code}
                            place={place}
                            codes={codes}
                            url={pageContext.url}
                            bread={bread}
                            keygroup_name={keygroup_name}
                            class='breadcrumb-banner'
                        />
                    </div>
                </div>
                <div className="left-side-dumpster">
                    <Banner
                    code={code}
                    codes={codes}
                    env={env}
                    title={title}
                    url={pageContext.url}
                    place={place}
                    breadcrumb={true}
                    bread={bread}
                    keygroup_name={keygroup_name}
                    />
                    {code === 'dumpster' &&
                    <div className="container">
                        <TypicalPricesChart typicalPricesData={typicalPricesData} cityName={place.name.split(', ')[0]} />
                        <ComparePricesLinks place={place} services={related} />
                    </div>
                    }
                    <div id="sponsored-profiles-id-list" className="div d-none" data-htcode={code === 'dumpster' ? 'dumpster-rental' : code === 'comercial-trash-service' ? 'commercial-waste-management' : code}>{pageContext.sponsoredPros}</div>
                    {/* Section 1 — Opening paragraph (PPP only) */}
                    {isPPP && pppOpeningParagraph && (
                        <div className="container ppp-intro-section" style={{paddingLeft: '30px'}}>
                            <p className="ppp-intro-text">{pppOpeningParagraph}</p>
                        </div>
                    )}

                    {/* Section 2 — Top Deals for You (PPP only) */}
                    {isPPP && sponsoredProfiles?.length > 0 &&
                    <>
                        <div className="container">
                            <h2 className="cards-title" style={{display: 'flex', justifyContent: 'space-between'}}>
                                <span>Top Deals for You</span>
                                <span style={{fontSize: '16px', color: 'rgba(0, 0, 0, 0.6)', fontWeight: 'normal'}}>Sponsored</span>
                            </h2>
                        </div>
                        <ProfilesCardsDumpster
                            profiles={sponsoredProfiles}
                            env={env}
                            code={code}
                            place={place}
                            cards={sponsoredCards}
                            online_booking_pros={online_booking_pros}
                            paginated={false}
                            eventClass="sponsoredProCardRendered"
                            cardClass="sponsored-card-pro-view"
                            pppPrices={pppPrices}
                            bookingCallback={serviceSeekerCallback}
                            onCardDetailsClick={handleCardDetailsClick}
                            ondeffCallback={ondeffCallback}
                            overridePlaceId={userPlaceId}
                            pagePlaceId={pageContext.place.i}
                            pageWasteType={pageWasteType}
                        />
                    </>
                    }

                    {/* Section 3 — All Dumpster Results (PPP only) */}
                    {isPPP && (
                    <>
                        <div className="container">
                            <h2 className="cards-title" style={{ marginTop: '40px' }}>
                                {`All "${singularize(projectTypeName)}" Prices in ${place.name}`}
                            </h2>
                        </div>
                        {allResultsCount === 0 ? (
                            <>
                                <div className="container ppp-no-results" style={{paddingLeft: '30px'}}>
                                    <p>We're sorry! There are no results for {place.name} {singularize(projectTypeName?.toLowerCase())} prices. Request quotes below.</p>
                                </div>
                                <div className="container"><div className="row justify-content-center"><div className="col-12 col-md-8 col-lg-6 mb-4">
                                    <PppGetMoreQuotesCard proCount={(profiles.length + (sponsoredProfiles?.length || 0)) - Object.keys(pppPrices).length} projectTypeName={projectTypeName} placeName={place.name} googlePlaceAutocompleteApiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`} />
                                </div></div></div>
                            </>
                        ) : (
                            <>
                                <ProfilesCardsDumpster
                                    profiles={[...(sponsoredProfiles || []), ...(profiles || [])]}
                                    env={env}
                                    code={code}
                                    place={place}
                                    cards={{ ...(sponsoredCards || {}), ...(cards || {}) }}
                                    online_booking_pros={online_booking_pros}
                                    paginated={false}
                                    eventClass="pppServiceCardRendered"
                                    cardClass=""
                                    pppPrices={pppPrices}
                                    mode="all-services"
                                    bookingCallback={serviceSeekerCallback}
                                    onCardDetailsClick={handleCardDetailsClick}
                                    ondeffCallback={ondeffCallback}
                                    onLoaded={(hasRealPrices) => setCardsHaveRealPrices(hasRealPrices)}
                                    overridePlaceId={userPlaceId}
                                    pagePlaceId={pageContext.place.i}
                                    pageWasteType={pageWasteType}
                                    appendCard={allResultsCount < 3 ? <PppGetMoreQuotesCard proCount={(profiles.length + (sponsoredProfiles?.length || 0)) - Object.keys(pppPrices).length} projectTypeName={projectTypeName} placeName={place.name} cardsHaveRealPrices={cardsHaveRealPrices} googlePlaceAutocompleteApiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`} /> : undefined}
                                />
                            </>
                        )}
                    </>
                    )}

                    {/* Section 4 — Sponsored service providers */}
                    {sponsoredProfiles?.length > 0 &&
                    <>
                        <div className="container">
                            <h2 className="cards-title" style={{ marginTop: '40px' }}>Sponsored service providers</h2>
                        </div>
                        <ProfilesCardsDumpster
                            profiles={sponsoredProfiles}
                            env={env}
                            code={code}
                            place={place}
                            cards={sponsoredCards}
                            online_booking_pros={online_booking_pros}
                            paginated={false}
                            eventClass="sponsoredProCardRendered"
                            cardClass="sponsored-card-pro-view"
                            pppPrices={{}}
                        />
                    </>
                    }

                    {/* Section 5 — All service providers */}
                    <div id="profiles-id-list" className="div d-none" data-htcode={code === 'dumpster' ? 'dumpster-rental' : code === 'comercial-trash-service' ? 'commercial-waste-management' : code}>{pageContext.pros}</div>

                    {empty && <EmptyProfilesDumpster code={code} />}

                    {!empty &&
                    <>
                        <div className="container">
                            <h2 className="cards-title" style={{ marginTop: '40px' }}>
                                {`All "${singularize(projectTypeName)}" service providers in ${place.name} - ${new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })}`}
                            </h2>
                        </div>
                        <ProfilesCardsDumpster
                            profiles={profiles}
                            env={env}
                            code={code}
                            place={place}
                            cards={cards}
                            online_booking_pros={online_booking_pros}
                            paginated={true}
                            eventClass="proCardRendered"
                            cardClass="card-pro-view"
                            pppPrices={{}}
                        />
                    </>
                    }
                    {code === 'dumpster' && isMobile &&
                    <div className="kpp-video-container-desktop">
                        <h2>Get Dumpster Pricing and Availability in {place.name}</h2>
                        <div class="howvideo services mb-5">
                            <iframe
                                src='https://www.youtube-nocookie.com/embed/0QgduQnNCMM'
                                width="560"
                                height="315"
                                frameborder="0"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    }
                </div>
                <div id="kpp-sidebar-search-container" className={`col-4 view-prices-form${isMobile ? '' : ' fixed-right'}`}>
                    {(code === 'dumpster' || code?.includes('dumpster'))
                        ? <KppSidebarSearchForm place={place} />
                        : <SidebarForm site={env.site} code={code} notShow={isHorizontal && isMobile}/>
                    }
                </div>
            </div>}

            {cardDetailsData && (
                <div className="container">
                    <div className="ppp-service-detail">
                        {showFailureMessage ? (
                            <div className="ppp-service-detail__failure">
                                <div className="back-container" onClick={handleBackFromCardDetails} style={{ cursor: 'pointer' }}>
                                    <span className="back-label">← Back</span>
                                </div>
                                <p className="ppp-service-detail__failure-message">
                                    No matching dumpsters found for this company. They may not accept this waste or may not serve this address. Go to <a href={`${process.env.GATSBY_SITE_DOMAIN}/book`} className="not-found-services-link">{process.env.GATSBY_SITE_DOMAIN}/book</a> to see companies that match your search.
                                </p>
                            </div>
                        ) : (
                            <ServiceDetail
                                proId={cardDetailsData.profileData?.proId}
                                apolloURL={apolloURL}
                                gatsbyKey={pageContext.gatsbyKey}
                                imageStaticEnv={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                                service={cardDetailsData.service}
                                services={cardDetailsData.proServices || [cardDetailsData.service]}
                                placeId={cardDetailsData.placeId}
                                changeService={handleChangeServiceInDetails}
                                currentWasteType={detailWasteType}
                                onViewPricing={() => ondeffCallback(cardDetailsData.profileData?.proId)}
                                onClickBook={() => serviceSeekerCallback([
                                    { key: 'service', value: cardDetailsData.service },
                                    { key: 'profileData', value: cardDetailsData.profileData },
                                    { key: 'proUrl', value: cardDetailsData.proUrl },
                                    { key: 'placeId', value: cardDetailsData.placeId },
                                ])}
                                changeTemplate={handleBackFromCardDetails}
                                setShowFailureMessage={setShowFailureMessage}
                                profileData={cardDetailsData.profileData}
                                callBy='book'
                            />
                        )}
                    </div>
                </div>
            )}

            {showBooking && (
                <div className="container">
                    <div className="row">
                        <div className="mid col-12">
                            <div className="content">
                                <div className="box order-container">
                                    <div id="online-booking" className="online-booking">
                                        <Suspense fallback={null}>
                                            <OnlineBooking
                                                handleBack={handleBackOnlineBooking}
                                                proId={bookingProInfo.proId}
                                                proName={bookingProInfo.proName}
                                                apolloURL={apolloURL}
                                                stripeApiKey={`${process.env.GATSBY_STRIPE_API_KEY}`}
                                                googlePlaceAutocompleteApiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`}
                                                initialData={bookingInitialData}
                                                proPhone=""
                                                backUrl={bookingProInfo.backUrl}
                                                gatsbyKey={pageContext.gatsbyKey}
                                                label='Boton'
                                                size='lg'
                                                staticUrl={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                                                maxDatePicker={process.env.MAX_DATE_PICKER}
                                                trackBookingSubmission={trackBookingSubmission}
                                            />
                                        </Suspense>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!showBooking && !cardDetailsData && (
            <div className="pt-5 pb-5 left-side-dumpster" >
                <div className="container ">
                    <div className="column">
                        {related?.length > 0 && <div className="col-md-12"><RelatedServices env={env} services={related} place={place} code={code} /></div>}
                        {populars?.length > 0 && <div className="col-md-12"><PopularServices env={env} services={populars} place={place} code={code} /></div>}
                        {!isPPP &&
                        <div className="col-md-12">
                            {code !== 'junk-removal' ?
                            <HowToGuide />
                            :
                            <BlockHowToGuidesJunkRemoval />
                            }
                        </div>
                        }
                    </div>
                    {!isPPP && <div className='stateArticles'><PopularArticlesKpp articles={articles} /></div>}
                </div>
            </div>
            )}

            {!showBooking && !cardDetailsData && !isPPP &&
            <div className="container-fuild left-side-dumpster">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <KppTips tip={tip} codes={codes} code={code} place={place} />
                        </div>
                    </div>
                </div>
            </div>
            }
        </LayoutDumpster>
    )
}

export default DumpsterKPP
